/**
 * Basic custom mobile validation
 * Min length 3, max length 14
 * No letters or duplicate +
 * @param phoneNumber
 * @returns errormessage
 */
export const validatePhoneNumber = (
    phoneNumber: string
): string | undefined => {
    const message = "Invalid mobile phone number";
    const extension = Array.from(phoneNumber)[0];
    if (extension === "+") {
        phoneNumber = phoneNumber.substring(1);
    }
    if (
        phoneNumber.length < 3 ||
        phoneNumber.length > 14 ||
        isNaN(Number(phoneNumber)) ||
        phoneNumber.includes(".") ||
        phoneNumber.includes("+") // extension has already been removed so no + should be present
    ) {
        return message;
    }
};
